import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { OldCall, ToolsService } from 'src/app/api/tools.service';
import { TableSkeletonComponent } from 'src/app/ui/skeletons/table-skeleton/table-skeleton.component';
import { TableColumnComponent, TableHeaderComponent, Column } from 'src/app/ui/tables';

@Component({
  selector: 'app-remove-old-consulting-calls',
  imports: [CommonModule,
    ReactiveFormsModule,
    DialogModule,
    TableModule,
    ButtonModule,
    CardModule,
    TableSkeletonComponent,
    TableColumnComponent,
    TableHeaderComponent,
    DatePickerModule
  ],
  templateUrl: './remove-old-consulting-calls.component.html',
  styleUrl: './remove-old-consulting-calls.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoveOldConsultingCallsComponent {
  
    maxDate = (() => {
      const date = new Date();
      date.setDate(date.getDate() - 90);
      return date;
    })();
    placeholderDate = this.maxDate.toISOString().split('T')[0];
  
    dateForm = new FormGroup({
      cutOffDate: new FormControl(this.placeholderDate, [Validators.required])
    });
  
    oldCalls = signal<OldCall[]>([]);
    isLoading = signal(false);
    hasSearched = signal(false);
    isApproving = signal(false);
  
    constructor(
      private toolsService: ToolsService,
      private messageService: MessageService
    ) { }
  
    callsColumns = signal<Column<OldCall>[]>([
      { field: 'custId', header: 'Customer ID', type: 'number', sortable: true, filterable: true },
      { field: 'groupname', header: 'Group Name', type: 'groupNameWithLink', custIdField: 'custId', sortable: true, filterable: true },
      { field: 'staff', header: 'Staff', type: 'text', sortable: true, filterable: true },
      { field: 'logtype', header: 'Type', type: 'logtype', sortable: true, filterable: true },
      { field: 'callDate', header: 'Date Scheduled', type: 'date', sortable: true, filterable: true },
    ]);
  
    onConfirmDate() {
      if (this.dateForm.valid) {
        this.isLoading.set(true);
        const cutOffDate = this.dateForm.value.cutOffDate!;
        this.toolsService.getOldConsultingCalls(cutOffDate).subscribe({
          next: (calls) => {
            console.log('Old Calls:', calls);
            this.oldCalls.set(calls);
            this.isLoading.set(false);
            this.hasSearched.set(true);
          },
          error: () => {
            this.isLoading.set(false);
          }
        });
      }
    }
  
    onApproveRemoval() {
      this.isApproving.set(true);
      let cutOffDate = this.dateForm.value.cutOffDate!;
      if ((cutOffDate as unknown) instanceof Date) {
        cutOffDate = ((cutOffDate as unknown) as Date).toISOString().split('T')[0];
      }
      this.toolsService.setInactiveOldConsultingCalls(cutOffDate).subscribe({
        next: () => {
          this.oldCalls.set([]);
          this.isApproving.set(false);
          this.messageService.add({
            severity: 'success',
            summary: 'Removal Complete',
            detail: 'Old recruiting calls have been removed successfully.',
            life: 3000
          });
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Removal Failed',
            detail: err?.message || 'Failed to remove old recruiting calls. Please try again.',
            life: 5000
          });
        }
      });
    }
  
  }
  
